import { dataCarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCarSolid = /*#__PURE__*/createIcon(dataCarSolid)
export default IconCarSolid
